import React from "react";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const InlineImage = ({ image, alignment, size, style }) => {
  return (
    <div
      className={`tps-inline-image-wrapper ${
        alignment === "Left"
          ? "tps-float-left"
          : alignment === "Right"
            ? "tps-float-right"
            : "tps-float-center"
      } tps-float-tablet ${style === "No Border" && "tps-no-border"} ${
        style === "Bordered (Grey)" && "tps-grey"
      }`}
    >
      <div
        className="tps-inline-image-inner"
        style={{ width: size === "Full (100%)" ? "100%" : "unset" }}
      >
        <Image
          src={getImageURL(image?.formats?.large?.url || image?.url)}
          alt={image?.alternativeText || ""}
          quality={90}
          placeholder="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII="
          loading="lazy"
          sizes="100vw"
          width={image?.width}
          height={image?.height}
          className={`tps-inline-image ${
            size === "Large (792px)"
              ? "tps-inline-image-size-large"
              : size === "Full (100%)"
                ? "tps-inline-image-size-full"
                : size === "Medium (486px)"
                  ? "tps-inline-image-size-medium"
                  : size === "Small (250px)"
                    ? "tps-inline-image-size-small"
                    : "tps-inline-image-size-default"
          }`}
          aria-hidden="true"
        />
        <div className="tps-inline-image-border" aria-hidden="true"></div>
      </div>
      {!!image?.caption && (
        <div
          className="tps-inline-image-caption"
          dangerouslySetInnerHTML={{ __html: image.caption }}
        ></div>
      )}
    </div>
  );
};

export default InlineImage;
